module.exports = __webpack_public_path__ + "img/image38.a7c063ee.png";